export default __webpack_public_path__ + "static/media/banner-img.1f858f31.png";